/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <ContentWithImage {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { ContentWithImage as ContentWithImageModule } from "@bw/modules"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
// parse is used to ensure that HTML sent by the CMS is converted to React components
import parse from "html-react-parser"

const ContentWithImage = ({
  suptitle,
  title,
  subtitle,
  text,
  orientation,
  image,
}) => {
  return (
    <Section
      suptitle={suptitle}
      title={title}
      subtitle={subtitle}
      containerSize="medium"
    >
      <ContentWithImageModule
        text={parse(text)}
        orientation={orientation}
        image={
          image ? (
            <GatsbyImage image={getImage(image.localImage)} alt="" />
          ) : null
        }
      />
    </Section>
  )
}

export default ContentWithImage

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on ContentWithImageModule {
 *   ...ContentWithImageModuleFragment
 * }
 *
 * This is also what you will get in the props of your ContentWithImage
 * resolver component.
 */
export const query = graphql`
  fragment ContentWithImageModuleFragment on ContentWithImageModule {
    image {
      localImage {
        childImageSharp {
          gatsbyImageData(width: 800, height: 600)
        }
      }
    }
    orientation
    text
  }
`
